"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appconfig = appconfig;
exports.getInitialState = void 0;
var actions = _interopRequireWildcard(require("../actions"));
var _constants = _interopRequireDefault(require("../constants"));
var _SessionStorage = _interopRequireDefault(require("../../shared/SessionStorage"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const defaultTo = (field, defaultValue, config) => {
  var _config$appFrame;
  const cachedConfig = _SessionStorage.default.get(_constants.default.APPCONFIG);
  if (cachedConfig && cachedConfig[field] !== undefined) {
    return cachedConfig[field];
  }
  if (((_config$appFrame = config.appFrame) === null || _config$appFrame === void 0 ? void 0 : _config$appFrame[field]) !== undefined) {
    var _config$appFrame2;
    return ((_config$appFrame2 = config.appFrame) === null || _config$appFrame2 === void 0 ? void 0 : _config$appFrame2[field]) === 'true';
  }
  return defaultValue;
};
const applyAppconfig = (current, next, config) => ({
  ...current,
  ...next,
  icon: next.icon || config.icon
});
const getInitialState = config => {
  var _config$appFrame3, _config$appFrame4, _config$appFrame5;
  return {
    fetching: true,
    entity: {
      logo: config.logo || '',
      icon: config.icon || '',
      favicon: '',
      defaultRoute: '',
      menu: defaultTo('menu', true, config),
      header: defaultTo('header', true, config),
      profile: ((_config$appFrame3 = config.appFrame) === null || _config$appFrame3 === void 0 ? void 0 : _config$appFrame3.profile) || 'on',
      notifications: ((_config$appFrame4 = config.appFrame) === null || _config$appFrame4 === void 0 ? void 0 : _config$appFrame4.notifications) || 'on',
      search: ((_config$appFrame5 = config.appFrame) === null || _config$appFrame5 === void 0 ? void 0 : _config$appFrame5.search) || 'on',
      sitemapCache: defaultTo('sitemapCache', true, config),
      hiddenMenu: defaultTo('hiddenMenu', false, config),
      collapsedMenu: defaultTo('collapsedMenu', false, config),
      mdsBreadcrumbs: true,
      accountPrefix: config.accountPrefix,
      menuL3AsSection: defaultTo('menuL3AsSection', true, config),
      headerBasedSitemap: defaultTo('headerBasedSitemap', false, config),
      isEmailTrackingEnabled: defaultTo('isEmailTrackingEnabled', false, config)
    }
  };
};
exports.getInitialState = getInitialState;
function appconfig(config) {
  return function (state = getInitialState(config), action) {
    switch (action.type) {
      case actions.GET_APP_CONFIG_PENDING:
        return {
          ...state,
          fetching: true
        };
      case actions.GET_APP_CONFIG_SUCCESS:
        {
          const entity = applyAppconfig(state.entity, action.payload.config, config);
          if (entity.headerBasedSitemap) {
            entity.menu = false;
            entity.header = true;
          }
          return {
            ...state,
            entity,
            fetching: false
          };
        }
      case actions.GET_APP_CONFIG_ERROR:
        return {
          ...state,
          fetching: false
        };
      default:
        return state;
    }
  };
}